import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import './EntryPage.css';

const ADMIN_PASSWORD = 'tobattle';
const API = process.env.REACT_APP_API_URL;

export default function EntryPage() {
  const navigate = useNavigate();

  const [showAdminPassword, setShowAdminPassword] = useState(false);
  const [password, setPassword] = useState('');
  const [allFencers, setAllFencers] = useState([]);
  const [query, setQuery] = useState('');
  const [suggestions, setSuggestions] = useState([]);
  const [selectedFencer, setSelectedFencer] = useState(null);
  const [error, setError] = useState('');
  const [loggedIn, setLoggedIn] = useState(false);
  const [code, setCode] = useState('');
  const [displaySpinner, setDisplaySpinner] = useState(false);

  /* ---------- Page styling ---------- */
  useEffect(() => {
    document.body.style.margin = '0';
    document.body.style.backgroundColor = '#000';
    return () => {
      document.body.style.margin = '';
      document.body.style.backgroundColor = '';
    };
  }, []);

  useEffect(() => {
    verifyFencer();

    fetch(`${API}/fencers`)
      .then(res => {
        if (!res.ok) throw new Error('Failed to fetch fencers');
        return res.json();
      })
      .then(setAllFencers)
      .catch(() => setError('Error loading fencers'));
  }, []);

  useEffect(() => {
    if (query.length < 2) {
      setSuggestions([]);
      setSelectedFencer(null);
      return;
    }

    const filtered = allFencers
      .filter(f => f.name.toLowerCase().startsWith(query.toLowerCase()))
      .slice(0, 10);

    setSuggestions(filtered);
  }, [query, allFencers]);

  const handleAdminClick = () => {
    setShowAdminPassword(true);
    setError('');
  };

  const handleAdminLogin = () => {
    if (password === ADMIN_PASSWORD) {
      localStorage.setItem('adminstatus', 'admingranted');
      navigate('/admin');
    } else {
      setError('Incorrect password');
    }
  };

  const handleLogin = async () => {
    try {
      setDisplaySpinner(true);
      const res = await fetch(`${API}/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ code: code.toLowerCase() }),
      });

      setDisplaySpinner(false);
      if (!res.ok) throw new Error('Invalid code');

      const data = await res.json();
      localStorage.setItem('fencerToken', data.token);
      verifyFencer();
    } catch {
      setError('Login failed. Try again.');
    }
  };

  const verifyFencer = async () => {
    const token = localStorage.getItem('fencerToken');
    if (!token) return setLoggedIn(false);

    try {
      const res = await fetch(`${API}/verify-token`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ token }),
      });

      if (!res.ok) return setLoggedIn(false);
      const data = await res.json();
      setLoggedIn(data.valid === true);
    } catch {
      setLoggedIn(false);
    }
  };

  const handleFencerSubmit = () => {
    if (!selectedFencer) {
      setError('Please enter your name and select it from the list');
      return;
    }

    localStorage.setItem('fencerId', selectedFencer.id);
    localStorage.setItem('fencerName', selectedFencer.name);
    navigate('/fencer', { state: { fencer: selectedFencer } });
  };

  if (!loggedIn) {
    return (
      <div className="entry-page">
        <h1>Please enter the code provided by the staff</h1>
        <input
          type="text"
          value={code}
          onChange={e => {
            setCode(e.target.value);
            setError('');
          }}
        />
        <button onClick={handleLogin} className='first-time-button'>Submit</button>
        {displaySpinner && <p className="loader">Loading...</p>}
        {error && <p className="error-message">{error}</p>}
        {/*<Link to='/register'>Not signed up? Register here!</Link>*/}
      </div>
    );
  }

  return (
    <div className="entry-page">
      <button className='signups-button' onClick={() => navigate('/signupsdisplay')}>View sign-ups</button>
      <button className='admin-button' onClick={handleAdminClick}>Admin</button>
      <h1>Welcome to Battle of the Bridge</h1>
      {!showAdminPassword ? (
        <>
          <input
            type="text"
            value={query}
            onChange={e => {
              setQuery(e.target.value);
              setError('');
            }}
          />
          {suggestions.length > 0 && !selectedFencer && (
            <ul className='fencer-select'>
              {suggestions.map(f => (
                <li
                  key={f.id}
                  onClick={() => {
                    setSelectedFencer(f);
                    setQuery(f.name);
                    setSuggestions([]);
                  }}
                >
                  {f.name} — {f.club}
                </li>
              ))}
            </ul>
          )}
          <button className='login-button' onClick={handleFencerSubmit}>Fencer Login</button>
        </>
      ) : (
        <>
          <input
            type="password"
            value={password}
            onChange={e => setPassword(e.target.value)}
          />
          <button onClick={handleAdminLogin} className='login-button'>Login</button>
          <button onClick={() => setShowAdminPassword(false)} className='login-button'>Back</button>
        </>
      )}
      {/*<Link to='/register'>Not signed up yet? Register here!</Link>*/}
      {error && <p className="error-message">{error}</p>}
    </div>
  );
}
